import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  statusLoading: false,
  statusPopup: false,
  popup_type_setup: "order_newest",
  popup_custom_list: [],
  template_popup_review_checkout: "medium",
  image_product_status_checkout: "square",
  color_border_image_checkout: "#F27321",
  status_border_checkout: true,
  color_makeup_image_checkout: "#F27321",
  status_makeup_image_checkout: true,
  makeup_icon_image_checkout: "star-1",
  status_makeup_icon_image_checkout: true,
  icon_rating_checkout: "star",
  color_icon_rating_checkout: "#FFDE55",
  title_popup_review_checkout: "Hi {{user_name}}",
  color_title_popup_review_checkout: "#000000",
  content_popup_review_checkout: "Thanks for buying, leave a review now!",
  color_content_popup_review_checkout: "#000000",
  text_rating_popup_review_checkout: "Rating",
  color_text_rating_popup_review_checkout: "#acabab",
  background_color_popup_review_checkout: "#ffffff",
  show_homepage_checkout: true,
  show_collections_page_checkout: true,
  show_product_detail_checkout: true,
  position_popup_checkout: "bottom_right",
  review_label_checkout: [
    "I'm very satisfied",
    "Good product",
    "Quality service",
    "Professional customer care",
  ],
  style_theme_checkout: "default",
  background_color_secondary_checkout: "#FAFBFD",

  // manually
  template_popup_review_manually: "medium",
  image_product_status_manually: "square",
  color_border_image_manually: "#F27321",
  status_border_manually: true,
  color_makeup_image_manually: "#F27321",
  status_makeup_image_manually: true,
  makeup_icon_image_manually: "star-1",
  status_makeup_icon_image_manually: true,
  icon_rating_manually: "star",
  color_icon_rating_manually: "#FFDE55",
  title_popup_review_manually: "Welcome customer",
  color_title_popup_review_manually: "#000000",
  content_popup_review_manually: "Big Sales! Please view and discuss together",
  color_content_popup_review_manually: "#000000",
  text_rating_popup_review_manually: "Rating",
  color_text_rating_popup_review_manually: "#acabab",
  background_color_popup_review_manually: "#ffffff",
  show_homepage_manually: true,
  show_collections_page_manually: true,
  show_product_detail_manually: true,
  position_popup_manually: "bottom_right",
  review_label_manually: [
    "I'm very satisfied",
    "Good product",
    "Quality service",
    "Professional customer care",
  ],
  style_theme_manually: "default",
  background_color_secondary_manually: "#FAFBFD",

  // order
  template_popup_review_order: "medium",
  image_product_status_order: "square",
  color_border_image_order: "#F27321",
  status_border_order: true,
  color_makeup_image_order: "#F27321",
  status_makeup_image_order: true,
  makeup_icon_image_order: "star-1",
  status_makeup_icon_image_order: true,
  icon_rating_order: "star",
  color_icon_rating_order: "#FFDE55",
  title_popup_review_order: "Welcome customer",
  color_title_popup_review_order: "#000000",
  content_popup_review_order: "Bestseller! You may be interested, view it now",
  color_content_popup_review_order: "#000000",
  text_rating_popup_review_order: "Rating",
  color_text_rating_popup_review_order: "#acabab",
  background_color_popup_review_order: "#ffffff",
  show_homepage_order: true,
  show_collections_page_order: true,
  show_product_detail_order: true,
  position_popup_order: "bottom_right",
  review_label_order: [
    "I'm very satisfied",
    "Good product",
    "Quality service",
    "Professional customer care",
  ],
  style_theme_order: "default",
  background_color_secondary_order: "#FAFBFD",

  // list product
  listProductByHandles: [],
});

let data;

const popupReviewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_RESULT_FIELD_POPUP_REVIEW:
      data = action.param;
      return state.set(data.field, data.value);

    case types.UPDATE_THEME_STYLE_POPUP_REVIEW: {
      data = action.payload;
      let newState = state;
      const keys = Object.keys(data);
      const values = Object.values(data);
      for (let index = 0; index < keys.length; index++) {
        const field = keys[index];
        const value = values[index];
        newState = newState.set(field, value);
      }

      return newState;
    }

    case types.CHANGE_STATUS_POPUP_REVIEW_RESULT:
      data = action.payload;
      return state.set("statusPopup", data);

    case types.GET_LIST_DETAIL_BY_HANDLES_RESULT:
      data = action.payload;
      return state.set("listProductByHandles", data);

    case types.GET_SETTINGS_POPUP_REVIEW_RESULT:
      data = action.payload;
      return (
        state
          .set("statusLoading", true)
          .set("statusPopup", data.popup_status)
          .set("popup_type_setup", data.popup_type_setup)

          .set(
            "template_popup_review_checkout",
            data.template_popup_review_checkout,
          )
          .set(
            "image_product_status_checkout",
            data.image_product_status_checkout,
          )
          .set("color_border_image_checkout", data.color_border_image_checkout)
          .set("status_border_checkout", data.status_border_checkout)
          .set("color_makeup_image_checkout", data.color_makeup_image_checkout)
          .set(
            "status_makeup_image_checkout",
            data.status_makeup_image_checkout,
          )
          .set("makeup_icon_image_checkout", data.makeup_icon_image_checkout)
          .set(
            "status_makeup_icon_image_checkout",
            data.status_makeup_icon_image_checkout,
          )
          .set("icon_rating_checkout", data.icon_rating_checkout)
          .set("color_icon_rating_checkout", data.color_icon_rating_checkout)
          .set("title_popup_review_checkout", data.title_popup_review_checkout)
          .set(
            "color_title_popup_review_checkout",
            data.color_title_popup_review_checkout,
          )
          .set(
            "content_popup_review_checkout",
            data.content_popup_review_checkout,
          )
          .set(
            "color_content_popup_review_checkout",
            data.color_content_popup_review_checkout,
          )
          .set(
            "text_rating_popup_review_checkout",
            data.text_rating_popup_review_checkout,
          )
          .set(
            "color_text_rating_popup_review_checkout",
            data.color_text_rating_popup_review_checkout,
          )
          .set(
            "background_color_popup_review_checkout",
            data.background_color_popup_review_checkout,
          )
          .set("show_homepage_checkout", data.show_homepage_checkout)
          .set(
            "show_collections_page_checkout",
            data.show_collections_page_checkout,
          )
          .set(
            "show_product_detail_checkout",
            data.show_product_detail_checkout,
          )
          .set("position_popup_checkout", data.position_popup_checkout)
          .set("review_label_checkout", fromJS(data.review_label_checkout))
          .set("style_theme_checkout", data.style_theme_checkout)
          .set(
            "background_color_secondary_checkout",
            data.background_color_secondary_checkout,
          )
          // manually
          .set(
            "template_popup_review_manually",
            data.template_popup_review_manually,
          )
          .set(
            "image_product_status_manually",
            data.image_product_status_manually,
          )
          .set("color_border_image_manually", data.color_border_image_manually)
          .set("status_border_manually", data.status_border_manually)
          .set("color_makeup_image_manually", data.color_makeup_image_manually)
          .set(
            "status_makeup_image_manually",
            data.status_makeup_image_manually,
          )
          .set("makeup_icon_image_manually", data.makeup_icon_image_manually)
          .set(
            "status_makeup_icon_image_manually",
            data.status_makeup_icon_image_manually,
          )
          .set("icon_rating_manually", data.icon_rating_manually)
          .set("color_icon_rating_manually", data.color_icon_rating_manually)
          .set("title_popup_review_manually", data.title_popup_review_manually)
          .set(
            "color_title_popup_review_manually",
            data.color_title_popup_review_manually,
          )
          .set(
            "content_popup_review_manually",
            data.content_popup_review_manually,
          )
          .set(
            "color_content_popup_review_manually",
            data.color_content_popup_review_manually,
          )
          .set(
            "text_rating_popup_review_manually",
            data.text_rating_popup_review_manually,
          )
          .set(
            "color_text_rating_popup_review_manually",
            data.color_text_rating_popup_review_manually,
          )
          .set(
            "background_color_popup_review_manually",
            data.background_color_popup_review_manually,
          )
          .set("show_homepage_manually", data.show_homepage_manually)
          .set(
            "show_collections_page_manually",
            data.show_collections_page_manually,
          )
          .set(
            "show_product_detail_manually",
            data.show_product_detail_manually,
          )
          .set("position_popup_manually", data.position_popup_manually)
          .set("review_label_manually", fromJS(data.review_label_manually))
          .set("style_theme_manually", data.style_theme_manually)
          .set(
            "background_color_secondary_manually",
            data.background_color_secondary_manually,
          )
          // order
          .set("template_popup_review_order", data.template_popup_review_order)
          .set("image_product_status_order", data.image_product_status_order)
          .set("color_border_image_order", data.color_border_image_order)
          .set("status_border_order", data.status_border_order)
          .set("color_makeup_image_order", data.color_makeup_image_order)
          .set("status_makeup_image_order", data.status_makeup_image_order)
          .set("makeup_icon_image_order", data.makeup_icon_image_order)
          .set(
            "status_makeup_icon_image_order",
            data.status_makeup_icon_image_order,
          )
          .set("icon_rating_order", data.icon_rating_order)
          .set("color_icon_rating_order", data.color_icon_rating_order)
          .set("title_popup_review_order", data.title_popup_review_order)
          .set(
            "color_title_popup_review_order",
            data.color_title_popup_review_order,
          )
          .set("content_popup_review_order", data.content_popup_review_order)
          .set(
            "color_content_popup_review_order",
            data.color_content_popup_review_order,
          )
          .set(
            "text_rating_popup_review_order",
            data.text_rating_popup_review_order,
          )
          .set(
            "color_text_rating_popup_review_order",
            data.color_text_rating_popup_review_order,
          )
          .set(
            "background_color_popup_review_order",
            data.background_color_popup_review_order,
          )
          .set("show_homepage_order", data.show_homepage_order)
          .set("show_collections_page_order", data.show_collections_page_order)
          .set("show_product_detail_order", data.show_product_detail_order)
          .set("popup_custom_list", data.popup_custom_list)
          .set("position_popup_order", data.position_popup_order)
          .set("review_label_order", fromJS(data.review_label_order))
          .set("style_theme_order", data.style_theme_order)
          .set(
            "background_color_secondary_order",
            data.background_color_secondary_order,
          )
      );

    default:
      return state;
  }
};

export default popupReviewReducer;
